import api from "../Service/Api";
import { toastr } from "react-redux-toastr";
import generalFunc from "../Utils/generalFunc";

const loanBeneficiaryBaseController = "api/LoanBeneficiary";
const paymentBaseController = "api/payment";

export const getTotalLoanBeneficiariesDetails = async body => {
  if (navigator.onLine === false) {
    toastr.error('No Internet Connection', 'Please try again');
  } else {
    try {
      const response = await api.get(`${loanBeneficiaryBaseController}/get-total-loan-beneficiaries-details`);
      if (typeof response !== 'undefined') {
        if (response.status === 200) {
          return response.data;
        }
      } else {
        toastr.error('An error occured', 'Please try again')
        console.log(response)
      }
    } catch (err) {
      console.log(err)
      // {
      //   "message": "Network Error",
      //   "name": "AxiosError",
      //   "stack": "AxiosError: Network Error\n    at XMLHttpRequest.handleError (https://localhost:44428/static/js/bundle.js:305277:14)",
      //   "config": {
      //     "transitional": {
      //       "silentJSONParsing": true,
      //       "forcedJSONParsing": true,
      //       "clarifyTimeoutError": false
      //     },
      //     "adapter": [
      //       "xhr",
      //       "http"
      //     ],
      //     "transformRequest": [
      //       null
      //     ],
      //     "transformResponse": [
      //       null
      //     ],
      //     "timeout": 0,
      //     "xsrfCookieName": "XSRF-TOKEN",
      //     "xsrfHeaderName": "X-XSRF-TOKEN",
      //     "maxContentLength": -1,
      //     "maxBodyLength": -1,
      //     "env": {},
      //     "headers": {
      //       "Accept": "application/json, text/plain, */*",
      //       "Access-Control-Allow-Methods": "*",
      //       "Access-Control-Allow-Headers": "Content-Type, Authorization"
      //     },
      //     "baseURL": "https://saedsidmach.azurewebsites.net/",
      //     "method": "get",
      //     "url": "api/LoanBeneficiary/get-total-loan-beneficiaries-details"
      //   },
      //   "code": "ERR_NETWORK",
      //   "status": null
      // }

      toastr.error(err.response.data.title)
    }
  }
}

function addParamsToURL(newValue, destination) {
  if (destination.slice(-13) === "beneficiaries") {
    return destination += `?${newValue}`
  } else {
    return destination += `&${newValue}`
  }
}

export const getAllLoanBeneficiariesAPI = async body => {
  if (navigator.onLine === false) {
    toastr.error('No Internet Connection', 'Please try again');
  } else {
    try {
      let requestString = `${loanBeneficiaryBaseController}/get-all-loan-beneficiaries`

      // add search param
      if (body?.Search) {
        requestString = addParamsToURL(`Search=${body?.Search}`, requestString)
      }

      // add pagination param
      if (body?.PageNumber) {
        requestString = addParamsToURL(`PageNumber=${body?.PageNumber}`, requestString)
      }

      const filterObject = body?.FilterOptions

      // add loan filter param
      if (filterObject?.Loan !== null) {
        filterObject?.Loan.map(loan => {
          requestString = addParamsToURL(`FilterOptions.Loan=${loan.value}`, requestString)
        })
      }

      // add status filter param
      if (filterObject?.Status !== "") {
        if (filterObject?.Status === 0) {
          requestString = addParamsToURL(`FilterOptions.Status=false`, requestString)
        } else if (filterObject?.Status === 1) {
          requestString = addParamsToURL(`FilterOptions.Status=true`, requestString)
        }
      }

      /*
        expects object
        if user is not filtering by any property, that property shouldn't be included in the FilterOptions object
        FilterOptions will always be present, if no filter is applied presently, it will be {}

          FilterOptions: { // both filters are applied
            Loan: [54, 43, 45],
            Status: "true",
          }
          FilterOptions: { // only status filter is applied
            Loan: null,
            Status: "true",
          }
          FilterOptions: { // on loan filter is applied
            Loan: [54, 43, 45],
            Status: "",
          }
          FilterOptions: { // no filter is applied
            Loan: null,
            Status: "",
          }
        */
      const response = await api.get(requestString);
      if (typeof response !== 'undefined') {
        if (response.status === 200) {
          return response.data;
        }
      } else {
        toastr.error('An error occured', 'Please try again')
        return false
      }
    } catch (err) {
      toastr.error(err.response.data.title)
      return false
    }
  }
}
export const getLoanBeneficiaryById = async body => {
  if (navigator.onLine === false) {
    toastr.error('No Internet Connection', 'Please try again');
  } else {
    // console.log("API parameters: ", body)
    try {
      let requestString = `${loanBeneficiaryBaseController}/get-loan-beneficiary-by-id?LoanBeneficiaryId=${body.LoanBeneficiaryId}`

      const response = await api.get(requestString);
      if (typeof response !== 'undefined') {
        if (response.status === 200) {
          return response.data;
        }
      } else {
        toastr.error('An error occured', 'Please try again')
        return false
      }
    } catch (err) {
      toastr.error(err.response.data.title)
      return false
    }
  }
}

export const getAllLoanBeneficiariesNoPagination = async body => {
  if (navigator.onLine === false) {
    toastr.error('No Internet Connection', 'Please try again');
  } else {
    try {
      const response = await api.get(`${loanBeneficiaryBaseController}/get-all-loan-beneficiary-no-pagination`);
      if (typeof response !== 'undefined') {
        if (response.status === 200) {
          return response.data;
        }
      } else {
        toastr.error('An error occured', 'Please try again')
      }
    } catch (err) {
      toastr.error(err.response.data.title)
    }
  }
}

export const addPaymentToLoanBeneficiaryAPI = async body => {
  if (navigator.onLine === false) {
    toastr.error('No Internet Connection', 'Please try again');
  } else {
    try {
      const response = await api.post(`${paymentBaseController}/add-payment`, body, {
        headers: {
          "Content-Type": "multipart/form-data",
        }
      },);
      if (typeof response !== 'undefined') {
        if (response.status === 200) {
          toastr.success('Payment added successfully')
          return response.data;
        }
      } else {
        toastr.error('An error occured', 'Please try again')
      }
    } catch (err) {
      toastr.error(err.response.data.title)
    }
  }
}

export const getPaymentByLoanBeneficiaryIdAPI = async body => {
  if (navigator.onLine === false) {
    toastr.error('No Internet Connection', 'Please try again');
  } else {
    try {
      const response = await api.get(`${paymentBaseController}/get-payment-by-loanbeneficiaryId/${body.loanBeneficiaryId}`);
      if (typeof response !== 'undefined') {
        if (response.status === 200) {
          return response.data;
        }
      } else {
        toastr.error('An error occured', 'Please try again')
      }
    } catch (err) {
      toastr.error(err.response.data.title)
    }
  }
}

export const getPaymentByPaymentIdAPI = async body => {
  if (navigator.onLine === false) {
    toastr.error('No Internet Connection', 'Please try again');
  } else {
    try {
      const response = await api.get(`${paymentBaseController}/get-payment-by-id/${body}`);
      if (typeof response !== 'undefined') {
        if (response.status === 200) {
          return response.data;
        }
      } else {
        toastr.error('An error occured', 'Please try again')
      }
    } catch (err) {
      toastr.error(err.response.data.title)
    }
  }
}

export const exportLoanBeneficiariesAPI = async body => {
  if (navigator.onLine === false) {
    toastr.error('No Internet Connection', 'Please try again');
  } else {
    try {
      const response = await api.get(`${loanBeneficiaryBaseController}/export-LoanBeneficiary`, { responseType: "blob" })
      if (typeof response !== 'undefined') {
        if (response.status === 200) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a")
          link.href = url
          link.setAttribute("download", `SAED Loan Beneficiaries ${generalFunc.getCurrentYear()}.xlsx`)
          document.body.appendChild(link)
          link.click()
          return true
        }
      } else {
        toastr.error('An error occured', 'Please try again')
      }
    } catch (err) {
      toastr.error(err.response.data.title)
      console.log(err)
      return err
    }
  }
}